<template>
  <div id="app" :class="{'remember-president': isRememberPresidentPage}">
    <el-scrollbar class="scrollbar" v-if="isRememberPresidentPage">
      <router-view />
    </el-scrollbar>
    <el-scrollbar class="scrollbar" v-else>
      <div class="header" v-if="!isHome">
        <div class="header-content">
          <div style="width:20px" v-if="isMobile"></div>
          <img
            class="logo"
            v-if="(webInfo || {}).websiteLogo"
            :src="webInfo.websiteLogo | imageUrl"
            @click="$router.push('/home')"
          />
          <img
            class="logo"
            v-else
            :src="require('@/assets/images/loginLogo.png')"
            @click="$router.push('/home')"
          />
          <Search v-if="!isMobile" :value="value" mini :display-hotword="false" @search="onSearch" />
          <div class="search" v-if="isMobile" @click="triggerSearch()">
            <el-icon name="search" />
          </div>
        </div>
      </div>
      <div v-if="showSearch && !isHome && isMobile" class="search-content">
        <el-autocomplete
          clearable
          style="width: 100%"
          v-model="value"
          :fetch-suggestions="getHistory"
          :placeholder="$t('components.search.placeholder')"
          @select="({ value }) => submitForm(value)"
          @change="value => submitForm(value)"
        />
      </div>
      <div class="breadcrumb" v-if="!isHome">
        <span v-if="!isMobile">{{ $t('current_location') }}</span>
        <Breadcrumb />
      </div>
      <router-view />
      <div class="footer">
        <div class="footer-content">
          <div class="link">
            <span>{{ $t('friend_link') }}</span>
            <a v-for="(link, key) in links" :key="key" :href="link.url" target="_blank">
              <el-image v-if="link.fileUrl" class="link-image" :src="link.fileUrl | imageUrl" />
              <span v-else>{{link.name}}</span>
            </a>
          </div>
          <div v-html="(webInfo || {}).bottom" />
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { isMobile, getDownloadUrl } from '@/utils/index'
import Breadcrumb from '@/components/Breadcrumb'
import Search from '@/components/Search'
import { getRelationshipList, getThemeConfig } from '@/api/home'
import cssVars from 'css-vars-ponyfill'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  components: {
    Search,
    Breadcrumb
  },
  data() {
    return {
      isMobile: isMobile(),
      showSearch: false,
      value: '',
      isHome: false,
      links: [],
      history: []
    }
  },
  computed: {
    ...mapGetters(['webInfo']),
    isRememberPresidentPage() {
      return !this.$route.name || this.$route.name === 'rememberPresident' || this.$route.name === 'poster'
    }
  },
  async created() {
    const history = localStorage.getItem('searchHistory') || ''
    this.history =
      history.split(',').map((item) => ({
        value: item
      })) || []
    const { data: themes = [] } = await getThemeConfig()
    const activeTheme = themes
      .filter((item) => !item.isDefault)
      .find((item) => moment().isBetween(item.publicStart, item.publishEnd))
    const defaultTheme =
      (activeTheme || {}).id || themes.find((item) => item.isDefault).id
    const theme =
      this.$route.query.theme || localStorage.getItem('theme') || defaultTheme
    document.body.className = `theme-${theme}`
    const defaultColor = [
      {
        '--primary': '#3999af',
        '--darken-primary': '#2c7789',
        '--lighten-primary': '#54b2c7'
      },
      {
        '--primary': '#323233',
        '--darken-primary': '#323233'
      },
      {
        '--primary': '#ee0a24',
        '--darken-primary': '#db0922'
      }
    ][theme - 1]
    cssVars({
      variables: defaultColor || {}
    })
    const { data: links } = await getRelationshipList()
    this.links = links
    const link = document.querySelector('link[rel="shortcut icon"]')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = (this.webInfo || {}).websitePic
      ? getDownloadUrl(this.webInfo.websitePic)
      : './favicon.ico'
  },
  methods: {
    getHistory(_queryString, cb) {
      cb(this.history)
    },
    submitForm(value) {
      if (!value && this.$route.name !== 'search') {
        return false
      }
      if (this.history.every((item) => item.value !== value)) {
        this.history.unshift({ value })
        if (this.history.length > 5) {
          this.history = this.history.slice(0, 5)
        }
        localStorage.setItem(
          'searchHistory',
          this.history.map((item) => item.value)
        )
      }
      this.showSearch = false
      this.onSearch(value)
    },
    triggerSearch() {
      this.showSearch = !this.showSearch
    },
    onSearch(text) {
      if (this.$route.name === 'search') {
        this.$root.eventHub.$emit('search', text)
      } else {
        this.$router.push({ name: 'search', query: { text }})
      }
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.isHome = route.name === 'home'
        this.value = (route.query || {}).text || ''
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.header {
  border-top: 10px solid var(--primary);
  background-color: $gray-2;

  &-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;

    .logo {
      cursor: pointer;
      height: 40px;
    }

    .search {
      font-size: 20px;
      color: #666;
      cursor: pointer;
      height: 40px;
      display: flex;
      align-items: center;
    }
  }
}
.search-content {
  padding: 10px;
  background-color: #f2f3f5;
}
@media (max-width: 800px) {
  .header-content {
    justify-content: space-between;
    .logo {
      height: 30px;
    }
  }
}

.remember-president {
  filter: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue